/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'fabric.elements.share.copied.to.clipboard.message': '링크를 클립보드에 복사함',
  'fabric.elements.share.copylink.button.text': '링크 복사',
  'fabric.elements.share.copypubliclink.button.text': '공개 링크 복사',
  'fabric.elements.share.failure.icon.label': '오류 아이콘',
  'fabric.elements.share.failure.message': '공유할 수 없음',
  'fabric.elements.share.form.comment.label': '메시지(선택 사항)',
  'fabric.elements.share.form.comment.placeholder': '사용자가 알아야 할 내용이 있습니까?',
  'fabric.elements.share.form.info.message.no.invite.confluence': '수신자가 페이지 이름과 메시지를 볼 수 있습니다',
  'fabric.elements.share.form.info.message.no.invite.jira': '수신자가 이슈 이름과 메시지를 볼 수 있습니다',
  'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh':
    '수신자가 업무 항목 이름 및 메시지를 볼 수 있습니다',
  'fabric.elements.share.form.no-permissions': '공유할 권한이 없습니다.',
  'fabric.elements.share.form.public.send': '공개 링크 보내기',
  'fabric.elements.share.form.public.share': '공개 링크 공유',
  'fabric.elements.share.form.required-field.summary': '필수 필드는 별표로 표시되어 있습니다',
  'fabric.elements.share.form.retry': '다시 시도',
  'fabric.elements.share.form.send': '보내기',
  'fabric.elements.share.form.share': '공유',
  'fabric.elements.share.form.title': '공유',
  'fabric.elements.share.form.user-picker.add-more': '더 입력하세요',
  'fabric.elements.share.form.user-picker.label.confluence': '이름, 팀, 그룹 또는 이메일',
  'fabric.elements.share.form.user-picker.label.email-disabled-confluence': '이름, 팀 또는 그룹',
  'fabric.elements.share.form.user-picker.label.email-disabled-jira': '이름 또는 팀',
  'fabric.elements.share.form.user-picker.label.email-only': '이메일',
  'fabric.elements.share.form.user-picker.label.jira': '이름, 팀 또는 이메일',
  'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '"{inputValue}"에 대한 결과를 찾지 못했습니다.',
  'fabric.elements.share.form.user-picker.no-options.generic':
    '"{inputValue}"에 대한 결과를 찾지 못했습니다. 이메일 주소를 사용하여 사용자를 초대하세요.',
  'fabric.elements.share.form.user-picker.placeholder.confluence': '예: Maria, Team Orange, group-one',
  'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': '예: Maria, Team Orange',
  'fabric.elements.share.form.user-picker.placeholder.email-only': '예: maria@company.com',
  'fabric.elements.share.form.user-picker.placeholder.jira': '예: Maria, Team Orange, maria@company.com',
  'fabric.elements.share.form.user-picker.validation.required': '사용자, 그룹, 팀 또는 이메일을 하나 이상 선택하세요.',
  'fabric.elements.share.form.user-picker.validation.required-message.confluence':
    '사용자, 팀, 그룹 또는 이메일을 하나 이상 선택하세요',
  'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence':
    '사용자, 팀 또는 그룹을 하나 이상 선택하세요',
  'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira':
    '사용자 또는 팀을 하나 이상 선택하세요',
  'fabric.elements.share.form.user-picker.validation.required-message.email-only': '이메일을 하나 이상 선택하세요',
  'fabric.elements.share.form.user-picker.validation.required-message.jira':
    '사용자, 팀 또는 이메일을 하나 이상 선택하세요',
  'fabric.elements.share.in.integration.button': '{integrationName}에서 공유',
  'fabric.elements.share.invite.to.confluence': 'Confluence에 초대',
  'fabric.elements.share.invite.to.jira': 'Jira에 초대',
  'fabric.elements.share.main.tab.text.confluence': '페이지 공유',
  'fabric.elements.share.main.tab.text.jira': '이슈 공유',
  'fabric.elements.share.menu.email.label': '이메일',
  'fabric.elements.share.menu.slack.label': 'Slack',
  'fabric.elements.share.popup.label': '공유',
  'fabric.elements.share.success.message':
    '{object, select,blogpost {공유한 블로그 게시물}board {공유한 보드}calendar {공유한 캘린더}draft {공유한 초안}filter {공유한 필터}issue {공유한 이슈}summary {공유한 요약}list {공유한 목록}timeline {공유한 타임라인}form {공유한 양식}media {공유한 미디어}page {공유한 페이지}project {공유한 프로젝트}pullrequest {공유한 풀리퀘스트}question {공유한 질문}report {공유한 보고서}repository {공유한 리포지토리}request {공유한 요청}timeline {공유한 타임라인}site {공유한 사이트}space {공유한 스페이스}other {공유한 링크}}',
  'fabric.elements.share.to.integration.button': '{integrationName}에 공유',
  'fabric.elements.share.trigger.button.icon.label': '공유 아이콘',
  'fabric.elements.share.trigger.button.invite.text': '초대',
  'fabric.elements.share.trigger.button.text': '공유',
  'fabric.elements.share.trigger.button.tooltip.text': '공유',
};
